import { Helmet } from 'react-helmet-async';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/16/solid';
import PathwayDiagram from '@/components/GeneContent/PathwayDiagram';
import ErrorMessage from '@/components/UI/ErrorMessage';

export default function GenePathwaysPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const geneSymbol = searchParams.get('symbol') ?? '';
  const navigationState = (location.state ?? {}) as {
    from?: { pathname?: string; search?: string; hash?: string };
  };

  const handleBack = () => {
    if (navigationState.from?.pathname) {
      navigate(
        `${navigationState.from.pathname}${navigationState.from.search ?? ''}${navigationState.from.hash ?? ''}`,
      );
      return;
    }

    navigate(-1);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Helmet>
        <title>DISGENET: Gene Pathways{geneSymbol ? ` — ${geneSymbol}` : ''}</title>
        <meta name="description" content="Pathway diagram for the selected gene." />
      </Helmet>

      <header
        style={{
          padding: '12px 24px',
          borderBottom: '1px solid #e0e8f0',
          background: '#fff',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <button
          type="button"
          onClick={handleBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#0d6efd',
            fontSize: 14,
            padding: '4px 0',
          }}
          aria-label="Go back"
        >
          <ArrowLeftIcon style={{ width: 16, height: 16 }} />
          Back
        </button>

        <div style={{ width: 1, height: 20, background: '#dee2e6' }} />

        <h1
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 700,
            color: '#1a2e44',
          }}
        >
          Pathways
          {geneSymbol && (
            <span
              style={{
                marginLeft: 8,
                fontWeight: 400,
                color: '#5a7a9a',
                fontSize: 15,
              }}
            >
              — {geneSymbol}
            </span>
          )}
        </h1>
      </header>

      <div style={{ flex: 1, overflow: 'auto', padding: '16px 24px' }}>
        {geneSymbol ? (
          <PathwayDiagram geneSymbol={geneSymbol} />
        ) : (
          <ErrorMessage
            title="No gene specified"
            subtitle={<span>Please navigate here from a gene info button.</span>}
          />
        )}
      </div>
    </div>
  );
}
